<template>
  <div>
    <Modal v-model="visible" title="批量更新保单基本信息" :footer-hide="true" :mask-closable="false" class="my-modal top" width="600px">
      <div style="margin-top: 10px">
        操作步骤：<br />
        1、在列表根据查询条件或使用【批量查询】搜索出需要更新基本信息的保单<br />
        2、点击【导出要修改的数据】，勾选要更新的字段后导出<br />
        3、将新的字段值更新到Excel后导入<br /><br />
        提示：基本信息不包含费用归属、产品档次、承保时间、保费、保单状态等数据，这类数据如需修改请在页面上操作。<br />
        注意：<span style="color: #e3461f"> 平台保单不支持手动更新，所有导入数据将自动过滤平台单，</span>单次导入最多1000条数据。
      </div>

      <div class="ivu-modal-footer">
        <Button type="text" @click="exportData">导出要修改的数据</Button>
        <Button type="primary" @click="$refs.importModal.open({ upload: '/buz/grouppolicy/batchUpdateImport' })">导入修改后的Excel</Button>

        <!-- <Upload
          ref="upload"
          :show-upload-list="false"
          class="upload-btn"
          :max-size="2048"
          :data="{}"
          :before-upload="handleBeforeUpload"
          action="/"
        >
      <Button type="primary">导入修改后的Excel</Button>
    </Upload> -->
      </div>
    </Modal>
    <Modal v-model="visible1" title="设置要导出和更新的字段" :mask-closable="false" width="670" class="my-modal import-tool-modal2">
      <div class="basic-info-box" v-for="(bean, i) in list" :key="i">
        <span class="title">{{ bean.menuName }}</span>
        <CheckboxGroup v-model="bean.values" class="check-group">
          <Checkbox :label="item.name" class="check" v-for="(item, index) in bean.list" :key="index" :disabled="!!item.isMust">
            <span class="label-name" :class="{ 'disabled': item.isMust }">{{ item.name }}</span>
            <Poptip trigger="hover" placement="top-start" :offset="-24" transfer-class-name="my-poptip" v-if="item.tips">
              <span class="tip-icon">?</span>
              <div slot="content">
                <span>{{ item.tips }}</span>
              </div>
            </Poptip>
          </Checkbox>
        </CheckboxGroup>
      </div>
      <div class="ivu-modal-footer" slot="footer">
        <Button type="text" @click="visible1 = false">取消</Button>
        <Button type="text" @click="reset">重置</Button>
        <Button type="primary" @click="confirm">确认导出</Button>
      </div>
    </Modal>
    <!-- 导入保单  -->
    <import-modal ref="importModal" :title="'批量更新基础信息'" code="groupPolicyUpdate" @success="$emit('toggleTab')"></import-modal>
  </div>
</template>

<script>
import importModal from '@/pages/orderManage/insuredOrder/components/importModal';
export default {
  props: ['searchParams'],
  components: {
    importModal
  },
  data() {
    return {
      visible: false,
      visible1: false,
      fileFormat: ['xls', 'xlsx', 'XLS', 'XLSX'],
      list: [],
      allData: []
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    exportData() {
      this.visible1 = true;
      this.getConfig();
    },
    reset() {
      this.list.forEach(item => {
        item.values = [];
        item.list.forEach(item2 => {
          if (item2.isMust) {
            item.values.push(item2.name);
          }
        });
      });
    },
    confirm() {
      const data = [];
      this.list.forEach(item => {
        item.list.forEach(item2 => {
          if (item.values.includes(item2.name)) {
            data.push(item2.name);
          }
        });
      });
      // 去重
      const result = Array.from(new Set(data));
      this.$http({
        url: '/buz/importTask/importTemplateConfig',
        type: 'POST',
        data: {
          code: 'groupPolicyUpdate',
          fields: result
        }
      }).then(res => {
        if (res.httpCode == '1') {
          if (result.length > 1) {
            this.visible1 = false;
          }
          let params = JSON.parse(JSON.stringify(this.searchParams));
          this.$emit('setListParams', params);
          this.$nextTick(() => {
            this.$units.downloadFile('/buz/grouppolicy/batchUpdateExport', params, 'POST');
          });
        }
      });
    },
    getConfig() {
      this.$http({
        url: '/buz/importTask/exportFields',
        type: 'GET',
        data: {
          code: 'groupPolicyUpdate'
        }
      }).then(res => {
        res.data.forEach(item => {
          item.values = [];
          item.list.forEach(item2 => {
            if (item2.isMust || item2.isExist) {
              item.values.push(item2.name);
            }
          });
        });
        this.list = res.data;
      });
    },
    handleBeforeUpload(file) {
      const format = file.name.split('.')[1];
      if (!this.fileFormat.includes(format)) {
        this.$notice.msg('请上传' + this.fileFormat.join(',') + '格式的文件');
        return false;
      }
      let formData = new FormData();
      formData.append('file', file);
      const params = {};
      if (params) {
        for (const key in params) {
          if (Object.hasOwnProperty.call(params, key)) {
            const element = params[key];
            formData.append(key, element);
          }
        }
      }
      this.loading = true;
      this.$http({
        type: 'POST',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        url: '/buz/grouppolicy/batchUpdateImport',
        data: formData
      })
        .then(res => {
          this.visible = false;
          this.$emit('searchAjax');
        })
        .finally(() => {
          this.loading = false;
        });

      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ {
  .ivu-btn {
    width: 130px !important;
  }
  .upload-btn {
    display: inline-block;
    margin-left: 20px;
  }
}
.import-tool-modal2 /deep/ {
  .basic-info-box {
    margin-top: 20px;
    .title {
      display: block;
      font-size: 12px;
      color: #515c6f;
      font-weight: bold;
    }
    .check-group {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .check {
        margin-top: 10px;
        width: 23.6%;
        span {
          margin-left: 4px;
        }
        & .disabled {
          color: #515c6f;
        }
        .tip-icon {
          width: 15px;
          height: 15px;
          border-radius: 15px;
          background: transparent;
          border: 1px solid #ccc;
          color: #ccc;
          display: inline-block;
          text-align: center;
          line-height: 15px;
          font-size: 12px;
          cursor: pointer;
          top: 50%;
        }
        .label-name {
          font-size: 12px;
        }
      }
    }
  }
}
</style>